import * as NewsApi from 'AgentNewsAdministration/api/agentNewsApi';
import {AgentNewsActionType, changeNews, getNews, deleteNewsEntry} from 'AgentNewsAdministration/ducks/news';
import {NewsEntryDto} from 'AgentNewsAdministration/models/Dtos/AgentNewsEntry';
import {AsyncResult, fromResult, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import {AgentNewsDto} from 'Agent/AgentInformation/api';
import {createSnackbar} from 'Core/ducks/snackbar';

export function* getNewsFromApi(action: ReturnType<typeof getNews>) {
  if (action.payload.page) {
    action.payload.page.links.forEach(x => {
      if (!x.href.includes('api/agent')) {
        x.href = 'api/agent'+ x.href;
      }  
    });
  yield put(changeNews(new LoadingAdditional(action.payload.page)));
} else {
    yield put(changeNews(new Loading(action.payload.page)));
  }

  const result: AsyncResult<Page<NewsEntryDto>> = yield action.payload.page
    ? call(mergeWithNextPage, {existingPage: action.payload.page})
    : call(NewsApi.getAgentNews, action.payload.filter);

  yield pipe(
    result,
    E.map(fromResult),
    E.fold(
      value => put(changeNews(value)),
      value => put(changeNews(value))
    )
  );
}

export function* getNewsSaga() {
  yield takeLatest(AgentNewsActionType.GET_NEWS, getNewsFromApi);
}

export function* deleteNewsEntryFromApi(action: ReturnType<typeof deleteNewsEntry>) {
  const {id} = action.payload;

  const result: AsyncResult<AgentNewsDto> = yield NewsApi.deleteAgentNewsEntry(id);

  const actionToTake = pipe(
    result,
    E.fold(
      (): unknown => put(createSnackbar('There Was a Problem Loading the News Entry.')),
      () => put(getNews())
    )
  );

  yield actionToTake;
}

export function* deleteNewsEntrySaga() {
  yield takeLatest(AgentNewsActionType.DELETE_NEWS_ENTRY, deleteNewsEntryFromApi);
}

export default function*() {
  yield all([getNewsSaga(), deleteNewsEntrySaga()]);
}
